import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "../../../axios";
import formatCurrency from "../../../utils/formatCurrency";
import { STORAGE_URL } from "../../../constants";

export default function OrderDetailPage() {
    const { id } = useParams();
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        axios.get(`/admin/orders/${id}`).then((res) => setOrder(res.data));
    }, [id]);

    const handleVerify = async () => {
        setLoading(true);
        try {
            await axios.post(`/admin/orders/${id}/verify`);
            setOrder({ ...order, status: "verified" });
        } catch {
            alert("Gagal memverifikasi pesanan.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelivery = async () => {
        setLoading(true);
        try {
            await axios.post(`/admin/orders/${id}/delivery`);
            setOrder({ ...order, status: "delivery" });
        } catch {
            alert("Gagal mengirim pesanan.");
        } finally {
            setLoading(false);
        }
    }     

    function StatusBadge({ status }) {
        let color = "secondary";
        let label = status;
        switch (status) {
            case "pending":
                color = "warning";
                label = "Pending";
                break;
            case "paid":
                color = "info";
                label = "Paid";
                break;
            case "verified":
                color = "success";
                label = "Verified";
                break;
            case "canceled":
                color = "danger";
                label = "Canceled";
                break;
            default:
                color = "secondary";
        }
        return (
            <span className={`badge bg-${color} text-capitalize`}>
                {label}
            </span>
        );
    }

    if (!order) return <p>Memuat detail pesanan...</p>;

    const shippingCost = parseInt(order.shipping_cost || 0);
    const subtotal = parseInt(order.price_total || 0);
    const uniqueCode = parseInt(order.unique_code || 0);
    const total = subtotal + shippingCost + uniqueCode;

    return (
        <div className="container py-5">
            <div className="card shadow">
                <div className="card-header bg-secondary text-white">
                    <h4 className="mb-0">Invoice Pesanan</h4>
                </div>

                <div className="card-body">
                    <div className="row mb-4">
                        {/* <div className="col-md-6">
                            <h5 className="mb-2">Dari:</h5>
                            <p className="mb-1"><strong>Nama Toko Album Foto</strong></p>
                            <p>Email: admin@albumfoto.com</p>
                        </div> */}
                        <div className="col-md-6 text-md-start">
                            <h5 className="mb-2">Customer:</h5>
                            <p className="mb-1"><strong>{order.user?.name}</strong></p>
                            <p>No HP: {order.user?.phone}</p>
                        </div>
                        <div className="col-md-6 text-md-start">
                            <h5 className="mb-2">Alamat Pengiriman:</h5>
                            <div className="shipping-info">
                                {order.shipping_address ? (
                                    <>
                                        <p className="mb-1">{order.shipping_address}</p>
                                        {/* Kota dan Provinsi dari API Ongkir */}
                                        {(order.city_name || order.province_name || order.destination_city || order.destination_province) && (
                                            <p className="mb-1">
                                                <span className="text-muted">
                                                    {order.city_name || order.destination_city || order.city}
                                                    {(order.city_name || order.destination_city || order.city) && 
                                                     (order.province_name || order.destination_province || order.province) && ', '}
                                                    {order.province_name || order.destination_province || order.province}
                                                </span>
                                            </p>
                                        )}
                                        {/* Kode pos jika ada */}
                                        {order.postal_code && (
                                            <p className="mb-1">
                                                <strong>Kode Pos:</strong> {order.postal_code}
                                            </p>
                                        )}
                                        {order.shipping_service && (
                                            <p className="mb-1">
                                                <strong>Layanan:</strong> {order.shipping_service}
                                            </p>
                                        )}
                                        {order.shipping_cost && (
                                            <p className="mb-1">
                                                <strong>Ongkir:</strong> Rp {formatCurrency(order.shipping_cost)}
                                            </p>
                                        )}
                                        {/* Estimasi pengiriman jika ada */}
                                        {order.shipping_estimate && (
                                            <p className="mb-1">
                                                <strong>Estimasi:</strong> {order.shipping_estimate} hari
                                            </p>
                                        )}
                                    </>
                                ) : (
                                    <p className="text-muted">Alamat pengiriman belum diisi</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div className="row mb-4">
                        <div className="col-md-12">
                            <p><strong>ID Pesanan:</strong> {String(order.id).substring(0, 8).toUpperCase()}</p>
                            <p><strong>Status:</strong> <StatusBadge status={order.status} /></p>
                            <p><strong>Tanggal:</strong> {new Date(order.created_at).toLocaleString()}</p>
                        </div>
                    </div>

                    <table className="table table-bordered">
                        <thead className="table-light">
                            <tr>
                                <th>Produk</th>
                                <th>Ukuran</th>
                                <th>Cover Design</th>
                                <th>Cover Fabric</th>
                                <th>Halaman</th>
                                <th>Harga Produk</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{order.product?.name}</td>
                                <td>{order.size?.width} cm x {order.size?.height} cm</td>
                                <td>{order.cover_design?.name}</td>
                                <td>{order.cover_fabric?.name}</td>
                                <td>{order.pages} halaman</td>
                                <td className="text-end">Rp {formatCurrency(subtotal)}</td>
                            </tr>
                            <tr>
                                <td colSpan="5" className="text-end"><strong>Subtotal Produk</strong></td>
                                <td className="text-end">Rp {formatCurrency(subtotal)}</td>
                            </tr>
                            {shippingCost > 0 && (
                                <tr>
                                    <td colSpan="5" className="text-end"><strong>Biaya Pengiriman</strong></td>
                                    <td className="text-end">Rp {formatCurrency(shippingCost)}</td>
                                </tr>
                            )}
                            <tr>
                                <td colSpan="5" className="text-end"><strong>Kode Unik</strong></td>
                                <td className="text-end">Rp {formatCurrency(uniqueCode)}</td>
                            </tr>
                            <tr className="table-light">
                                <td colSpan="5" className="text-end"><strong>Total Pembayaran</strong></td>
                                <td className="text-end"><strong>Rp {total.toLocaleString("id-ID")}</strong></td>
                            </tr>
                        </tbody>
                    </table>

                    {order.proof_file ? (
                        <div className="mt-4">
                            <h5>Bukti Transfer:</h5>
                            <img
                                src={`${STORAGE_URL}${order.proof_file}`}
                                alt="Bukti Transfer"
                                style={{ maxWidth: 400, border: "1px solid #ccc" }}
                            />
                        </div>
                    ) : (
                        <div className="alert alert-warning mt-4">Belum ada bukti transfer diunggah.</div>
                    )}

                    {order.status === 'submitted' || order.status === 'delivery' && (
                        <div className="mt-4">
                            <h5>File Foto</h5>
                            <div className="row mt-4">
                                {order.photos.map((photoUrl, index) => (
                                    <div className="col-4 col-sm-3 col-md-2 mb-3" key={index}>
                                        <div className="position-relative">
                                            <img
                                                src={`${STORAGE_URL}${photoUrl}`}
                                                className="img-fluid rounded border"
                                                alt={`photo-${index}`}
                                            />


                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {order.status === "paid" && (
                        <button onClick={handleVerify} className="btn btn-success mt-3" disabled={loading}>
                            {loading ? "Memverifikasi..." : "Verifikasi Pesanan"}
                        </button>
                    )}

                    {order.status === "submitted" && (
                        <button onClick={handleDelivery} className="btn btn-success mt-3" disabled={loading}>
                            {loading ? "Memproses..." : "Proses Kirim"}
                        </button>
                    )}

                    <div className="mt-4">
                        <Link to="/admin/orders" className="btn btn-secondary">← Kembali ke Daftar Pesanan</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}